import { useEffect } from 'react'
import { RefreshCw } from 'lucide-react'
import { Button } from '@klear/ui/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@klear/ui/components/card'

type UpdateRequiredScreenProps = {
  logoSrc?: string
}

export function UpdateRequiredScreen({ logoSrc }: UpdateRequiredScreenProps) {
  useEffect(() => window.location.reload(), [])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      {logoSrc && (
        <img
          alt="Klear"
          width="180"
          height="48"
          decoding="async"
          className="h-12 w-auto mb-8 dark:invert"
          src={logoSrc}
          style={{ color: 'transparent' }}
        />
      )}
      <Card className="w-full max-w-md shadow-xl dark:border-white/10 dark:bg-muted/40">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted dark:border dark:border-white/10 dark:bg-background">
            <RefreshCw className="h-6 w-6 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl font-bold">A new version is available</CardTitle>
          <CardDescription>
            This page is running an older version of Klear. Reload to continue with the current one.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          <Button className="w-full" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <p className="text-xs text-muted-foreground">Anything you have not saved will be lost.</p>
        </CardContent>
      </Card>
    </div>
  )
}
